
module.exports = (s) => {
  return [
    {
      name: 'ID',
      value: 'type_id',
      props: {
        fixed: 'left',
        width: 150,
      },
    },
    {
      name: '所属广告账号',
      value: 'advertiser_id',
      props: {
        fixed: 'left',
        width: 150,
      },
    },
    {
      name: '项目名称',
      value: 'name',
      props: {
        fixed: 'left',
        width: 150,
      },
    },
    {
      name: '推广目的',
      value: 'landing_type',
      format: ({ landing_type }) => {
        return s.$store.getters.jrttEnumVal.api_2_landing_type[landing_type];
      },
    },
    {
      name: '推广子目的',
      value: 'app_promotion_type',
      props: {
        width: 100,
      },
      format: ({ app_promotion_type }) => {
        return s.$store.getters.jrttEnumVal.api_2_app_promotion_type[app_promotion_type];
      },
    },
    {
      name: '营销场景',
      value: 'marketing_goal',
      props: {
        width: 120,
      },
      format: ({ marketing_goal }) => {
        return s.$store.getters.jrttEnumVal.api_2_marketing_goal[marketing_goal];
      },
    },
    {
      name: '广告类型',
      value: 'ad_type',
      format: ({ ad_type }) => {
        return s.$store.getters.jrttEnumVal.api_2_ad_type[ad_type];
      },
    },
    {
      name: '目标操作',
      value: 'opt_status',
      props: {
        width: 100,
      },
      format: ({ opt_status }) => {
        return opt_status === 'ENABLE' ? '启用项目' : '暂停项目';
      },
    },
    {
      name: '项目创建时间',
      value: 'project_create_time',
      props: {
        width: 100,
      },
    },
    {
      name: '项目更新时间',
      value: 'project_modify_time',
      props: {
        width: 100,
      },
    },
    {
      name: '项目状态',
      value: 'status',
      props: {
        width: 100,
      },
      format: ({ status }) => {
        return s.project_form_config.status_form.config?.status?.enumVal?.[status];
      },
    },
    {
      name: '出价方式',
      value: 'pricing',
      props: {
        width: 100,
      },
    },
    {
      name: '应用包名',
      value: 'package_name',
      props: {
        width: 100,
      },
    },
    {
      name: '应用名',
      value: 'app_name',
      props: {
        width: 100,
      },
    },
    {
      name: '资产类型',
      value: 'asset_type',
      props: {
        width: 100,
      },
    },
    {
      name: '小游戏类型',
      value: 'micro_promotion_type',
      props: {
        width: 100,
      },
      format: ({ micro_promotion_type }) => {
        return s.$store.getters.jrttEnumVal.api_2_micro_promotion_type?.[micro_promotion_type];
      },
    },
    {
      name: '下载链接',
      value: 'download_url',
      props: {
        width: 100,
      },
    },
    {
      name: '下载方式',
      value: 'download_type',
      props: {
        width: 100,
      },
      format: ({ download_type }) => {
        return s.project_form_config.target_form.config?.download_type?.enumVal?.[download_type];
      },
    },
    {
      name: '下载模式',
      value: 'download_mode',
      props: {
        width: 100,
      },
      format: ({ download_mode }) => {
        return s.project_form_config.target_form.config?.download_mode?.enumVal?.[download_mode];
      },
    },
    {
      name: '调起方式',
      value: 'launch_type',
      props: {
        width: 100,
      },
      format: ({ launch_type }) => {
        return s.project_form_config.target_form.config?.launch_type?.enumVal?.[launch_type];
      },
    },
    {
      name: '创建时间',
      value: 'created_time',
      props: {
        width: 100,
      },
    },
    {
      name: '最后更新时间',
      value: 'updated_time',
      props: {
        width: 100,
      },
    },
    {
      name: '首选位置',
      value: 'delivery_range.inventory_type',
      props: {
        width: 200,
      },
      format: ({ delivery_range }) => {
        return delivery_range.inventory_type?.map((item, index) => {
          return s.$store.getters.jrttEnumVal.ad_inventory_type[item] + (index < (delivery_range.inventory_type.length - 1) ? '、' : '');
        });
      },
    },
    {
      name: '对应平台（IOS & Android）',
      value: 'platform',
      props: {
        width: 200,
      },
      format: ({ platform }) => {
        return s.$store.getters.jrttEnumVal.api_2_platforms[platform];
      },
    },
    {
      name: '操作',
      value: 'adgroup_name',
      props: {
        fixed: 'right',
        align: 'center',
        width: 256,
      },
      format: (row) => {
        const h = s.$createElement;
        const ele = h('div',
          null, [
            h('el-button',
              {
                props: {
                  size: 'mini',
                },
                on: {
                  click: () => {
                    s.editProject(row);
                  },
                },
              },
              '编辑'
            ),
            h('el-button',
              {
                props: {
                  size: 'mini',
                },
                on: {
                  click: () => {
                    s.$router.push({
                      path: '/superior/superior-jrtt/ad-manage',
                      query: {
                        advertiser_id: row.advertiser_id,
                        project_id: row.type_id,
                      },
                    });
                  },
                },
              },
              '查看广告'
            ),
            h('el-button',
              {
                props: {
                  size: 'mini',
                  type: 'success',
                },
                on: {
                  click: () => {
                    s.$router.push({
                      path: '/superior/superior-jrtt/report/project-report',
                      query: {
                        advertiser_id: row.advertiser_id,
                        project_id: row.type_id,
                      },
                    });
                  },
                },
              },
              '查看报表'
            ),
          ]
        );

        return ele;
      },
    },
  ];
};
